export const getLocalesMatcher = (locale, LOCALE_CONSTANT) => {
  if (!locale) {
    return LOCALE_CONSTANT.default;
  }
  const normalizedLocale = locale.replace('_', '-');
  return LOCALE_CONSTANT[normalizedLocale] || LOCALE_CONSTANT.default;
};
